// components/ForceReloadButton.jsx
import React from 'react';

const ForceReloadButton = () => {
  const forceReload = () => {
    // Esto simula Ctrl + F5 forzando la recarga con caché ignorada
    window.location.reload(true); // true ya no se usa mucho, pero sigue funcionando en navegadores
  };

  return (
    <button
      onClick={forceReload}
    //   style={{
    //     position: 'fixed',
    //     top: 10,
    //     right: 10,
    //     padding: '8px 12px',
    //     background: '#007bff',
    //     color: '#fff',
    //     border: 'none',
    //     borderRadius: '4px',
    //     zIndex: 9999,
    //     cursor: 'pointer'
    //   }}
    className='bg-[#0B3C5D30] hover:bg-orange-500 py-1 px-2.5 text-[1.1rem] rounded-lg text-white font-semibold'
    >
      <i className="fa-solid fa-rotate"/>
    </button>
  );
};

export default ForceReloadButton;
